import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "@/lib/translations";

export const LANGS = [
  { code: "it", name: "Italiano" },
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
  { code: "de", name: "Deutsch" },
];

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("imperiale_lang") || "it");

  useEffect(() => {
    localStorage.setItem("imperiale_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t: TRANSLATIONS[lang] || TRANSLATIONS.it }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
